import "../styles/HeaderContainer.scss";

function HeaderContainer({ children }: any) {
    return <header className="header-container">{children}</header>;
}

export default HeaderContainer;
